import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import {
  getLocalStorageItem,
  setLocalStorageItem,
  SETTINGS_RECENT_TAGS,
  SETTINGS_MAX_RECENT_TAGS,
} from '@/stores/localStorage';

export const DEFAULT_MAX_RECENT_TAGS = 5;

export const useRecentTagsStore = defineStore('recentTags', () => {
  const tags = ref<string[]>(getLocalStorageItem(SETTINGS_RECENT_TAGS, []));
  const maxTags = ref<number>(getLocalStorageItem(SETTINGS_MAX_RECENT_TAGS, DEFAULT_MAX_RECENT_TAGS));

  watch(tags, (v) => setLocalStorageItem(SETTINGS_RECENT_TAGS, v), { deep: true });
  watch(maxTags, (v) => setLocalStorageItem(SETTINGS_MAX_RECENT_TAGS, v));

  /**
   * Record a tag as recently used.
   * Tags are tracked independently; a tag can be both favorite and recent.
   * Moves the tag to the front; trims list to maxTags.
   */
  function record(tag: string) {
    if (!tag) return;
    const filtered = tags.value.filter((t) => t !== tag);
    filtered.unshift(tag);
    tags.value = filtered.slice(0, maxTags.value);
  }

  function remove(tag: string) {
    tags.value = tags.value.filter((t) => t !== tag);
  }

  return {
 tags,
maxTags,
record,
remove,
};
});
